import '../player'


// WEBPACK FOOTER //
// ./app/javascript/packs/player.js